// extracted by mini-css-extract-plugin
export var colorBase = "AzhyPyL7Bk3e1HHoPaKR";
export var colorDisabled = "B_abLWcx3yJQhoIugDmM";
export var colorInverted = "ZZ7C5ksRsdTA6QOKYfuc";
export var colorNegative = "L466e8OBlCfjfs7I8Sqt";
export var colorPositive = "uFpJNmTGK0AVKiH0yDqX";
export var colorSubdued = "DJRwCfrAi4xuSqbZljWc";
export var colorSubtle = "JJqbf1Kp44MSH4qh_2G6";
export var colorUrgencyHigh = "rMMQY8iurNazI85j6jTO";
export var colorUrgencyMedium = "MGu256r3sAEDK5yKDpoH";
export var colorWarning = "voYgAmuRKVPhKmsSxHmi";
export var colorWhite = "BByuPxsR8LSGG8q2pxrD";